import { Badge } from '@/components/ui/badge'
import { Text } from '@/components/ui/text'
import type { Duration } from '@hvf/contracts'
import type { Component, JSX } from 'solid-js'
import { Flex } from 'styled-system/jsx'

interface DurationDisplayProps {
  duration: Duration
}

/**
 * Simple Solid component that shows a label and a badge depending on duration.
 * Uses inline styles for a minimal, framework-agnostic badge layout.
 */
export const DurationDisplay: Component<DurationDisplayProps> = (props) => {
  const durationMap: Record<Duration, JSX.Element> = {
    intraday: (
      <Flex justifyContent="space-between" alignItems="center" w='full'>
        <Text>&lt; Daily</Text>
        <Badge
          ml="auto"
          children="Linear"
        />
      </Flex>
    ),
    multiday: (
      <Flex justifyContent="space-between" alignItems="center" w='full'>
        <Text>Daily +</Text>
        <Badge
          ml="auto"
          children="Log"
        />
      </Flex>
    ),
  }

  return durationMap[props.duration]
}
